<!-- Header -->
<header class="header">
	<nav class="navbar navbar-expand-lg header-nav">
		<div class="navbar-header">
			<a id="mobile_btn" href="javascript:void(0);">
				<span class="bar-icon">
					<span></span>
					<span></span>
					<span></span>
				</span>
			</a>
			<a routerLink='' class="navbar-brand logo">
				<img [src]="logo" style="max-height: 60px;" class="img-fluid" alt="Logo">
			</a>
		</div>
		<div class="main-menu-wrapper">
			<div class="menu-header">
				<a routerLink='' class="menu-logo">
					<img [src]="logo" class="img-fluid" alt="Logo">
				</a>
				<a id="menu_close" class="menu-close" href="javascript:void(0);">
					<i class="fas fa-times"></i>
				</a>
			</div>
			<!-- for mobile -->
			<ul class="main-nav">
				<li routerLinkActive="active">
					<a routerLink=''>Home</a>
				</li>
				<!-- <li class="has-submenu">
					<a href="javascript:;">Language<i class="fas fa-chevron-down"></i></a>
					<ul class="submenu">
						<li><a href="javascript:;" (click)="changeLanguage('en')">{{'english' | translate}}</a></li>
						<li><a href="javascript:;" (click)="changeLanguage('ar')">{{'arabic' | translate}}</a></li>
						<li><a href="javascript:;" (click)="changeLanguage('ur')">{{'urdu' | translate}}</a></li>
					</ul>
				</li> -->
				<li class="login-link" *ngIf="!isLoggedin">
					<a routerLink="/accounts/login">{{'loginSignUp' | translate}}</a>
				</li>
				<li class="login-link" *ngIf="!isLoggedin">
					<a routerLink="/accounts/register/agree/mentor">{{'mentorregister' | translate}} </a>
				</li>
			</ul>	
				 <!-- end for mobile -->
		</div>		 
		<ul class="nav header-navbar-rht">
			<li class="nav-item">
				<ul class="main-nav">
					<li class="has-submenu">
						<a href="javascript:;">{{'Language' | translate}}<i class="fas fa-chevron-down"></i></a>
						<ul class="submenu">
							<li><a href="javascript:;" (click)="changeLanguage('en')">{{'english' | translate}}</a></li>
							<li><a href="javascript:;" (click)="changeLanguage('hi')">{{'hindi' | translate}}</a></li>
							<li><a href="javascript:;" (click)="changeLanguage('ba')">{{'bangla' | translate}}</a></li>
							<li><a href="javascript:;" (click)="changeLanguage('ur')">{{'urdu' | translate}}</a></li>
						</ul>
					</li>
				</ul>
			</li>
			<li class="nav-item contact-item">
				<div class="header-contact-img">
					<i class="far fa-hospital"></i>							
				</div>
				<div class="header-contact-detail">
					<p class="contact-header">{{'contact' | translate}}</p>
					<p class="contact-info-header"> +92 321 966 5502</p>
				</div>
			</li>

			<!-- User Menu -->
			<li class="nav-item dropdown has-arrow logged-item" *ngIf="isLoggedin">
				<a href="#" class="dropdown-toggle nav-link" data-toggle="dropdown">
					<span class="user-img">
						<img class="rounded-circle" src="{{profilePicture}}" width="31" alt="Darren Elder">
					</span>
				</a>
				<div class="dropdown-menu dropdown-menu-right">
					<div class="user-header">
						<div class="avatar avatar-sm">
							<img src="{{profilePicture}}" alt="User Image" class="avatar-img rounded-circle">
						</div>
						<div class="user-text">
							<h6>{{userName | titlecase}}</h6>
							<p class="text-muted mb-0">{{userRole | uppercase}}</p>
						</div>
					</div>
					<ng-container *ngIf="userRole.toLowerCase() === role.Mentor">
						<a class="dropdown-item" routerLink="/mentor/dashboard">{{'dashboard' | translate}}</a>
						<a class="dropdown-item" routerLink="/mentor/profile">{{'profileSettings' | translate}}</a>
					</ng-container>
					<ng-container *ngIf="userRole.toLowerCase() === role.Mentee">
						<a class="dropdown-item" routerLink="/mentee/dashboard">{{'dashboard' | translate}}</a>
						<a class="dropdown-item" routerLink="/mentee/profile">{{'profileSettings' | translate}}</a>
					</ng-container>
					<ng-container *ngIf="userRole.toLowerCase() === role.Admin">
						<a class="dropdown-item" routerLink="/admin/dashboard">{{'dashboard' | translate}}</a>
					</ng-container>
					
					<a class="dropdown-item" href="javascript:;" (click)="logout()">{{'logOut' | translate}}</a>
				</div>
			</li>

			<li class="nav-item" *ngIf="!isLoggedin">
				<a class="nav-link header-login" routerLink="/accounts/register/agree/mentor">{{'mentorRegister' | translate}} </a>
			</li>

			<li class="nav-item" *ngIf="!isLoggedin">
				<a class="nav-link header-login" routerLink="/accounts/login">{{'loginSignUp' | translate}} </a>
			</li>
		</ul>
	</nav>
</header>